export const NEVER_OWNED_APIS = {
  SAVE_FORM_DATA:
    "https://portal.acrossassist.com/api/partner/v1/dmi/SaveNeverOwnedDetails",
  // "https://gadgetuatapi.acrossassist.in/api/partner/v1/NeverOwned/SaveNeverOwnedDetails",

  GET_PLANS:
    "https://portal.acrossassist.com/api/partner/v1/dmi/GetPlanForNever_Owned",
};
